<div
  class="relative bg-white shadow-2xl max-w-md w-[350px] rounded-2xl overflow-hidden border border-gray-200 border-px"
  (mouseenter)="pauseTimer.set(true)"
  (mouseleave)="pauseTimer.set(false)">
  <div class="flex items-center justify-between pt-3 px-2">
    <div class="flex items-center space-x-2">
      <div class="flex-shrink-0">
        @switch (toastRef.data.type) { @case ('success') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6 text-green-500">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path
            d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" />
        </svg>
        } @case ('error') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6 text-red-500">
          <path
            fill-rule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
            clip-rule="evenodd" />
        </svg>
        } @case ('info') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6 text-blue-500">
          <path
            d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" />
        </svg>
        } @case ('warning') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6 text-yellow-500">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path
            d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" />
        </svg>
        } }
      </div>
      <div class="text-foreground font-medium text-sm">
        {{ toastRef.data.title }}
      </div>
    </div>

    <div class="flex items-center space-x-2">
      <button
        (click)="toastRef.close({ dismissedByAction: true })"
        class="p-1 rounded hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
        aria-label="Close">
        <svg
          class="w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  </div>

  @if (toastRef.data.message) {
  <div class="px-4">
    <div class="text-muted-foreground text-sm leading-relaxed mt-1">
      {{ toastRef.data.message }}
    </div>
  </div>
  }

  <div
    class="relative bg-gray-50 flex items-center overflow-hidden transition-all duration-200 ease-linear mt-1"
    [class.h-0]="isTimerStopped()"
    [class.h-8]="!isTimerStopped()">
    <div class="px-4 pb-1">
      <div class="flex items-center text-xs text-gray-500 gap-x-1">
        <span>
          This message will close in <b>{{ remainingTime() }}</b> second{{
          remainingTime() === 1 ? '' : 's' }}.
        </span>
        <button
          (click)="stopTimer()"
          class="text-gray-700 hover:text-gray-900 focus:outline-none decoration-0">
          Click to stop
        </button>
      </div>
    </div>
    <div
      [ngClass]="{
          'bg-green-500': toastRef.data.type === 'success',
          'bg-red-500': toastRef.data.type === 'error',
          'bg-blue-500': toastRef.data.type === 'info',
          'bg-yellow-500': toastRef.data.type === 'warning',
        }"
      class="absolute left-0 bottom-0 h-1 transition-all duration-1000 ease-linear shrink-line-animation"
      [class.animate-none]="isTimerStopped()"
      [style.animation-play-state]="pauseTimer() ? 'paused' : 'running'"
      [style.--shrink-line-animation-duration]="toastRef.getToast().duration + 'ms'"></div>
  </div>
</div>
